import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2e440dc2")

_pushScopeId("data-v-2e440dc2")
const _hoisted_1 = { class: "home-box" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "title" }, "欢迎使用医疗机构依法执业自查系统", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "bottom" }, "欢迎使用医疗机构依法执业自查系统，希望给您带来愉快的体验。客服热线：400-066-5755", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3
  ]))
})